import React from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
import { companyInfo } from '../../data/mockData';

export const HeroCTAGroup = ({ onExploreServices }) => (
  <div
    style={{
      display: 'flex',
      gap: '1rem',
      justifyContent: 'center',
      flexWrap: 'wrap',
      marginBottom: '3.5rem'
    }}
  >
    <button
      onClick={() => window.open(companyInfo.googleCalendarLink, '_blank')}
      className="btn-primary pulse"
      style={{ padding: '1.15rem 2.4rem', fontSize: '1.05rem' }}
      data-testid="hero-schedule-cta"
    >
      <Calendar size={20} />
      Schedule a Consultation
    </button>

    <button
      onClick={onExploreServices}
      className="btn-secondary"
      style={{ padding: '1.15rem 2rem', fontSize: '1rem' }}
      data-testid="hero-explore-services"
    >
      Explore Our Services
      <ArrowRight size={18} />
    </button>
  </div>
);
